<div class="box is-shadowless">
    <div class="box-content debits-box has-background-info-fade">
        <span class="columns is-mobile is-aligned-center">
            <div class="column is-narrow is-paddingless">
                <span class="icon is-medium has-text-secondary">
                    <i class="tri-gauge"></i>
                </span>
            </div>
            <div class="column is-paddingless">
                <p class="text is-level-3 is-marginless">
                    Option Débit+ jusqu'à 8 Gb/s disponible gratuitement à l'étape suivante.
                </p>
            </div>
        </span>
    </div>
</div>
